<template>
  <div class="ma-2">
    <v-card-title>
       {{ ura.description }}
    </v-card-title>

    <v-divider/>
    <v-row dense>
      <v-col cols="5" v-show="dataRotas" class="mr-4">
        <v-data-iterator
          :no-data-text="noDataText"
          :items="dataRotas"
          :items-per-page.sync="itemsPerPage"
          :page="pageRoutes"
          :no-results-text="noResultsText"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-data-table
              :headers="routesHeaders"
              :items="props.items"
              hide-default-footer
              class="elevation-1"
              disable-pagination
            >
            </v-data-table>
          </template>

          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="center">
              <div class="ml-4 mb-2 grey--text">
                <p>
                  Total de Rotas:
                  {{ dataRotas ? dataRotas.length : 0 }}
                </p>
              </div>
              <v-spacer />
              <div class="pb-5">
                <ListPagination
                  :page="pageRoutes"
                  :numberOfPages="numberOfPagesRoutes"
                  @firstPage="firstPageRoutes"
                  @formerPage="formerPageRoutes"
                  @nextPage="nextPageRoutes"
                  @lastPage="lastPageRoutes"
                />
              </div>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>  
    </v-row>  
      
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import ListPagination from '@/componentes/ListPagination'
import urasStore from '../_store'

export default {
  components: { ListPagination },
  name: 'Dialog',
  props: {
    ura: Object,
  },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    routesHeaders: [
        {
          text: 'Rota',
          value: 'route',
          align: 'left',
          width: '50%',
        },
        {
          text: 'Ação',
          value: 'action',
          align: 'left',
        },
    ],
    itemsPerPage: 5,
    pageRoutes: 1,
    dataRotas: [],
  }),
  async created() {
    registerVuexModule(this.$store, 'urasHomeModulePABXStore', urasStore)
  },
  computed: {
    ...mapGetters('urasHomeModulePABXStore', ['getUraUse']),
    numberOfPagesRoutes() {
      if(this.dataRotas){
       return Math.ceil(this.dataRotas.length / this.itemsPerPage)
      }
      return 0;
    },
  },
  methods: {
     firstPageRoutes() {
      if (this.pageRoutes > 1) {
        this.pageRoutes = 1
      }
    },
    formerPageRoutes() {
      if (this.pageRoutes > 1) {
        this.pageRoutes -= 1
      }
    },
    nextPageRoutes() {
      if (this.pageRoutes < this.numberOfPagesRoutes) {
        this.pageRoutes += 1
      }
    },
    lastPageRoutes() {
      if (this.pageRoutes < this.numberOfPagesRoutes) {
        this.pageRoutes = this.numberOfPagesRoutes
      }
    },
  },
  watch: {
    getFilaUse: {
      deep: true,
      immediate: true,
      handler() {
        this.dataRotas = this.getUraUse.routes
      },
    },
  },
}
</script>